<template>
  <div id="addLease">
    <div v-if="isOldData">
      <a-form layout="vertical" :form="leaseForm" selfUpdate>
        <span v-if="newsDO != null && newsDO.confidentialityStatus == 1"><pt-icon type="icon-baomi1"
                                                                                  style="font-size: 30px;"></pt-icon></span>
        <div class="statusRow">
          <div v-if="dealTypeList[0].active" class="statusSelected">{{ $t('track.trackType.新设立') }}</div>
          <div v-if="dealTypeList[1].active" class="statusSelected">{{ $t('track.trackType.搬迁') }}</div>
          <div v-if="dealTypeList[2].active" class="statusSelected">{{ $t('track.trackType.续租') }}</div>
          <div v-if="dealTypeList[3].active" class="statusSelected">{{ $t('track.trackType.租约重构') }}</div>
          <div v-if="dealTypeList[4].active" class="statusSelected">{{ $t('track.trackType.扩租') }}</div>
          <div v-if="dealTypeList[5].active" class="statusSelected">{{ $t('track.trackType.购买') }}</div>
        </div>
        <div class="greyDiv">
          <a-row>
            <a-col :span="16">
              <a-form-item :label="$t('lease.modal.company')">
                <pt-input disabled :value="newsDO.customerName"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.tradeLabel')">
                <pt-input disabled :value="newsDO.trade != '~' ? $t('news.dealForm.tradeList.' + newsDO.trade) : '~'">
                </pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.oldMansionLabel')">
                <pt-input disabled :value="newsDO.mansion == 'null' ? '~' : newsDO.mansion"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.newMansionLabel')">
                <pt-input disabled :value="newsDO.newBuilding"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.oldAreaLabel')">
                <pt-input disabled :value="newsDO.leaseArea"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.unitLabel')">
                <pt-input disabled :value="newsDO.unitCode"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.newAreaLabel')">
                <pt-input disabled :value="newsDO.newArea"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.rentPeriodLabel')">
                <pt-input disabled :value="newsDO.leaseTerm"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.rentAmountLabel')">
                <pt-input disabled :value="newsDO.rent"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.freeRentLabel')">
                <pt-input disabled :value="newsDO.rentFreePeriod"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.increasingLabel')">
                <pt-input disabled :value="newsDO.increasing"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.agentLabel')">
                <pt-select :disabled="true" :showArrow="!disabled"
                           :value="newsDO.intermediary == 0 ? '~' : newsDO.intermediary">
                  <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">{{ c.companySortNameCn }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.dealTimeLabel')">
                <pt-input disabled
                          :value="newsDO.dateTime != '~' ? $moment(newsDO.dateTime).format('YYYY-MM-DD') : '~'"></pt-input>
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.rentStartTimeLabel')">
                <pt-input disabled
                          :value="newsDO.startTime != '~' ? $moment(newsDO.startTime).format('YYYY-MM-DD') : '~'"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :label="$t('news.dealForm.remarksLabel')">
                <a-textarea
                  :rows="3"
                  disabled :value="newsDO.remark"></a-textarea>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
    <div v-else>
      <a-form layout="vertical" :form="leaseForm" selfUpdate>
        <span style="position: absolute;top: 184px;"
              v-if="newsDO != null && newsDO.confidentialityStatus == 1 && disabled"><pt-icon type="icon-baomi1"
                                                                                              style="font-size: 30px;"></pt-icon></span>
        <div class="statusRow" v-if="!disabled">
          <div  v-if="!newsDO || newsDO.dealType != '购买'" :class="dealTypeList[0].active ? 'statusSelected':'statusDefault'" @click="switchDealType(0)">
            {{ $t('track.trackType.新设立') }}
          </div>
          <div  v-if="!newsDO || newsDO.dealType != '购买'" :class="dealTypeList[1].active ? 'statusSelected':'statusDefault'" @click="switchDealType(1)">
            {{ $t('track.trackType.搬迁') }}
          </div>
          <div  v-if="!newsDO || newsDO.dealType != '购买'" :class="dealTypeList[2].active ? 'statusSelected':'statusDefault'" @click="switchDealType(2)">
            {{ $t('track.trackType.续租') }}
          </div>
          <div v-if="!newsDO || newsDO.dealType != '购买'" :class="dealTypeList[3].active ? 'statusSelected':'statusDefault'" @click="switchDealType(3)">
            {{ $t('track.trackType.租约重构') }}
          </div>
          <div v-if="!newsDO || newsDO.dealType != '购买'" :class="dealTypeList[4].active ? 'statusSelected':'statusDefault'" @click="switchDealType(4)">
            {{ $t('track.trackType.扩租') }}
          </div>
          <div v-if="!newsDO || newsDO.dealType == '购买'" :class="dealTypeList[5].active ? 'statusSelected':'statusDefault'" @click="switchDealType(5)">
            {{ $t('track.trackType.购买') }}
          </div>
        </div>
        <div class="statusRow" v-else>
          <div v-if="dealTypeList[0].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.新设立') }}
          </div>
          <div v-if="dealTypeList[1].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.搬迁') }}
          </div>
          <div v-if="dealTypeList[2].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.续租') }}
          </div>
          <div v-if="dealTypeList[3].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.租约重构') }}
          </div>
          <div v-if="dealTypeList[4].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.扩租') }}
          </div>
          <div v-if="dealTypeList[5].active" class="statusSelected" style="cursor: default">
            {{ $t('track.trackType.购买') }}
          </div>
        </div>
        <div class="greyDiv" v-if="!dealTypeList[5].active">
          <a-form-item v-show="false">
            <a-input v-decorator="['id',{}]"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="['mansionName',{}]"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="['version',{}]"></a-input>
          </a-form-item>
          <a-row v-if="!dealTypeList[1].active">
            <a-col :span="24">
              <a-form-item class="required" :label="$t('lease.modal.company')">
                <a-select
                  :disabled="!companyShow || disabled || isNewsAmendment"
                  showSearch
                  v-decorator="decorators.customerId"
                  :placeholder="$t('lease.modal.companyTip')"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearch"
                  :notFoundContent="null"
                  @change="customerIdChange"
                >
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addCustomerBtn" @click="openAddCustomerModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                        {{ $t('track.trackModal.addCustomer') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                    <div style="display:flex;">
                      <div :class="disabled?'':'invisible-item'">
                        {{ d.companyName }}
                      </div>
                      <div style="margin-left: 20px">
                        {{ d.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="dealTypeList[1].active">
            <a-col :span="16">
              <a-form-item class="required" :label="$t('lease.modal.company')">
                <a-select
                  :disabled="!companyShow || disabled || isNewsAmendment"
                  showSearch
                  v-decorator="decorators.customerId"
                  :placeholder="$t('lease.modal.companyTip')"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearch"
                  :notFoundContent="null"
                  @change="customerIdChange"
                >
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addCustomerBtn" @click="openAddCustomerModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                        {{ $t('track.trackModal.addCustomer') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                    <div style="display:flex;">
                      <div style="flex:1;" :class="disabled?'':'invisible-item'">
                        {{ d.companyName }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>
                      <div>
                        {{ d.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.oldBuildingLabel')">
                <a-select
                  :disabled="disabled"
                  :placeholder="$t('news.dealForm.oldBuildingTip')"
                  v-decorator="decorators.oldMansionId"
                  showSearch
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="initOldMansionOptions"
                  @change="oldBuildingChange"
                  :notFoundContent="null"
                >
                  <a-icon slot="suffixIcon" type="caret-down"/>
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addBottomBtn" @click="openAddMansionModal('old')">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{ $t('mansion.addMansion.addTitle') }}</div>
                    </div>
                  </div>
                  <a-select-option v-for="m in oldMansionOptions" :key="m.id" :value="m.id">
                    <div style="display: flex;overflow: hidden;justify-content: space-between">
                      <div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                        {{ m.name }}
                      </div>
                      <div>{{ m.province == 'hk' ? 'HK' : m.citys }}</div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('lease.modal.building')">
                <a-select
                  :disabled="unitVO != null || disabled"
                  :placeholder="$t('lease.modal.buildingTip')" v-decorator="decorators.mansion"
                  showSearch
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="initNewMansionOptions"
                  :notFoundContent="null"
                  @change="mansionIdChange"
                >
                  <a-icon slot="suffixIcon" type="caret-down"/>
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addBottomBtn" @click="openAddMansionModal('new')">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{ $t('mansion.addMansion.addTitle') }}</div>
                    </div>
                  </div>
                  <a-select-option v-for="m in mansionOptions" :key="m.id" :value="m.id">
                    <div style="display: flex;overflow: hidden;justify-content: space-between">
                      <div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                        {{ m.name }}
                      </div>
                      <div>{{ m.province == 'hk' ? 'HK' : m.citys }}</div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('news.dealForm.rentText')">
                <a-input-group compact>
                  <pt-input-number style="width:65%;" :max="99999999" :precision="2"
                                   :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.rent"
                                   :disabled="disabled"></pt-input-number>
                  <pt-unit-select style="width: 35%;" type="rent"  :show-arrow="false" v-decorator="decorators.rentUnit" disabled
                                  ></pt-unit-select>
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.freeMonthText')">
                <pt-input-number :max="99999999" :precision="2"
                  :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.rentFreePeriod" :disabled="disabled"
                  style="width: 100%;"
                ></pt-input-number>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="lease_floor" v-if="leaseLeaseInfoDetailsVOList">
            <pt-newObjectTag v-if="unitVO == null && !disabled" @click="addFloor"
                             style="position: absolute;right: 8px;top: 8px;z-index:2;"></pt-newObjectTag>
            <div v-for="f,index in leaseLeaseInfoDetailsVOList" :key="index">
              <a-form-item v-show="false">
                <a-input
                  v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].leaseId`]"
                ></a-input>
              </a-form-item>
              <a-form-item v-show="false">
                <a-input
                  v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].mansionId`]"
                ></a-input>
              </a-form-item>
              <a-col :span="8">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.floor') : null">
                  <pt-select
                    :showSearch="true"
                    :disabled="unitVO != null || disabled"
                    v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].floorId`,{rules: [

                      ],}]"
                    :placeholder="$t('lease.modal.selectTip')"
                    :allow-clear="false"
                    :showArrow="!disabled"
                  >
                    <a-select-option v-for="f in floorOptions" :key="f.id" :value="f.id">{{ f.floorNum }}
                    </a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.unitCodes') : null">
                  <pt-input
                    :disabled="unitVO != null || disabled"
                    v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].unitCodes`,{rules: [
                     {max:100,message:$t('lease.modal.unitCodeLengthTip')},
                    ],}]"
                    :placeholder="$t('lease.modal.inputTip')"
                  ></pt-input>
                </a-form-item>
              </a-col>
              <a-col :span="disabled ? 8 : 7">
                <a-form-item :label="index == 0 ? $t('lease.detail.LeaseLeaseinfoDetailsDO.areaSize') : null">
                  <a-input-group compact>
                    <pt-input-number style="width: 65%" :max="999999" :precision="2"
                                     :disabled="unitVO != null || disabled"
                                     v-decorator="[`leaseLeaseInfoDetailsVOList[${index}].areaSize`,{}]"
                                     :placeholder="$t('lease.modal.areaTip')"
                    >
                    </pt-input-number>
                    <pt-unit-select style="width: 35%;text-align: right;" type="area" :show-arrow="false"
                                    v-model="leaseLeaseInfoDetailsVOList[index].areaSizeUnit"
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="1" v-if="!disabled">
                <a-form-item :label="null" v-if="index > 0">
                  <div class="deleteBtn" @click="deleteFloorRow(index)" :style="index==0 ? 'margin-top:30px':''">
                    <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
                  </div>
                </a-form-item>
              </a-col>
            </div>
          </a-row>
          <a-row>
            <a-col :span="16" v-if="!dealTypeList[5].active">
              <a-form-item :label="$t('news.dealForm.leasePeriodText')" class="required">
                <pt-month-range style="width:100%;" @change="monthChange" v-decorator="decorators.dateRange"
                                :disabled="disabled" :dataButtonShow="true"></pt-month-range>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.signDateText')" class="required">
                <a-month-picker style="width:100%;" :placeholder="$t('news.dealForm.signDatePlaceholder')"
                                v-decorator="decorators.signTime" :disabled="disabled"></a-month-picker>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.dueDatePrice')">
                <pt-input
                  :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.dueDatePrice" :disabled="disabled"
                  style="width: 100%;"
                ></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('lease.modal.successBy')">
                <pt-select :placeholder="$t('lease.modal.selectTip')" show-search v-decorator="decorators.agent"
                           :disabled="disabled" :showArrow="!disabled">
                  <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">{{ c.companySortNameCn }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.remindDateText')">
                <pt-select v-decorator="decorators.dueTime" :placeholder="$t('lease.modal.dueTimeTip')"
                           :disabled="disabled">
                  <a-select-option :value="30">30{{ $t('baseVO.day') }}</a-select-option>
                  <a-select-option :value="60">60{{ $t('baseVO.day') }}</a-select-option>
                  <a-select-option :value="90">90{{ $t('baseVO.day') }}</a-select-option>
                  <a-select-option :value="180">180{{ $t('baseVO.day') }}</a-select-option>
                  <a-select-option :value="365">365{{ $t('baseVO.day') }}</a-select-option>
                  <a-select-option :value="545">{{ $t('common.eighteenMonths') }}</a-select-option>
                  <a-select-option :value="730">{{ $t('common.twoYears') }}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.dealForm.remarksLabel')">
                <pt-input :class="!disabled ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}"
                          v-decorator="decorators.remarks"
                          :placeholder="$t('lease.modal.remarksTip')" :disabled="disabled">
                </pt-input>
                <!--  <a-textarea :disabled="disabled"
                    :rows="3"
                    :placeholder="$t('lease.modal.remarksTip')"
                    v-decorator="decorators.remarks"
                  />-->
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="greyDiv" v-if="dealTypeList[5].active">
          <a-form-item v-show="false">
            <a-input v-decorator="['id',{}]"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="['mansionName',{}]"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="['version',{}]"></a-input>
          </a-form-item>
          <a-row>
            <a-col :span="24">
              <a-form-item class="required" :label="$t('lease.modal.company')">
                <a-select
                  :disabled="!companyShow || disabled || isNewsAmendment"
                  showSearch
                  v-decorator="decorators.customerId"
                  :placeholder="$t('lease.modal.companyTip')"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearch"
                  :notFoundContent="null"
                  @change="customerIdChange"
                >
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addCustomerBtn" @click="openAddCustomerModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                        {{ $t('track.trackModal.addCustomer') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                    <div style="display:flex;">
                      <div :class="disabled?'':'invisible-item'">
                        {{ d.companyName }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>
                      <div>
                        {{ d.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('keydasha')">
                <a-select
                  :disabled="unitVO != null || disabled"
                  :placeholder="$t('lease.modal.buildingTip')" v-decorator="decorators.newMansionId"
                  showSearch
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="initNewMansionOptions"
                  :notFoundContent="null"
                  @change="mansionIdChange"
                >
                  <a-icon slot="suffixIcon" type="caret-down"/>
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addBottomBtn" @click="openAddMansionModal('new')">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{ $t('mansion.addMansion.addTitle') }}</div>
                    </div>
                  </div>
                  <a-select-option v-for="m in mansionOptions" :key="m.id" :value="m.id">
                    <div style="display: flex;overflow: hidden;justify-content: space-between">
                      <div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                        {{ m.name }}
                      </div>
                      <div>{{ m.province == 'hk' ? 'HK' : m.citys }}</div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('key82louceng')">
                <pt-select
                  :showSearch="true"
                  :disabled="unitVO != null || disabled"
                  v-decorator="[`storeyIds`,{rules: [

                      ],}]"
                  :placeholder="$t('lease.modal.selectTip')"
                  :allow-clear="false"
                  :maxTagCount="3"
                  mode='multiple'
                  @change="floorNumChanges"
                  :showArrow="!disabled"
                >
                  <div slot="maxTagPlaceholder" scope="scope">
                    <a-tooltip :title="showFloor.join(' ')" placement="topRight">
                      <div>{{showFloor.length}}+...</div>
                    </a-tooltip>
                  </div>
                  <a-select-option v-for="f in floorOptions" :key="f.id" :value="f.id">{{ f.floorNum }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('key82xiangxixinxi')">
                <a-input-group compact>
                  <pt-input style="width:100%;" :disabled="disabled" v-decorator="decorators.comment"
                            :placeholder="$t('lease.modal.inputTip')" maxlength="255"></pt-input>
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('key82chengjiaomianji')">
                <a-input-group compact>
                  <pt-input-number style="width:100%;" @change="areaChange" :max="99999999" :precision="2"
                                   :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.area"
                                   :disabled="disabled"></pt-input-number>
                  <div style="position: absolute;white-space: nowrap;right: 5px;font-size: 12px;top: 8px;">{{(newsDO && newsDO.city == 'HK') || city.toUpperCase() == 'HK'?'sf':'㎡'}}</div>
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('common.estimatedDealPrice')">
                <a-input-group compact>
                  <pt-input-number style="width:100%;" @change="priceChange" :max="99999999" :precision="2"
                                   :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.price"
                                   :disabled="disabled"></pt-input-number>
                  <div style="position: absolute;white-space: nowrap;right: 5px;font-size: 12px;top: 8px;">{{(newsDO && newsDO.city == 'HK') || city.toUpperCase() == 'HK'?'million':$t('keywanyuan')}}</div>
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('key82chengjiaodanjian')">
                <a-input-group compact>
                  <pt-input-number style="width:100%;" :max="999999999" :precision="2"
                                   :placeholder="$t('lease.modal.inputTip')" v-decorator="decorators.unitPrice"
                                   :disabled="true"></pt-input-number>
                  <div style="position: absolute;white-space: nowrap;right: 5px;font-size: 12px;top: 8px;">{{(newsDO && newsDO.city == 'HK') || city.toUpperCase() == 'HK'?'psf':$t('keywanyuan')}}</div>
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('key82fukuanfangshi')">
                <pt-select :placeholder="$t('lease.modal.selectTip')" v-decorator="decorators.payType"
                           :disabled="disabled" :showArrow="!disabled">
                  <a-select-option :value="1">{{ $t('key82yicixing') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('key82fenqi') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('key82anjie') }}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('key82yongtu')">
                <pt-select :placeholder="$t('lease.modal.selectTip')" v-decorator="decorators.useType"
                           :disabled="disabled" :showArrow="!disabled">
                  <a-select-option :value="1">{{ $t('key82ziyong') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('key82touzi') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('key82ziyongjiantouzi') }}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('key82goumaifangshi')">
                <pt-select :placeholder="$t('lease.modal.selectTip')" v-decorator="decorators.purchaseType"
                           :disabled="disabled" :showArrow="!disabled">
                  <a-select-option :value="1">{{ $t('key82zichanjiaoyi') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('key82guquanjiaoyi') }}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.dealForm.signDateText')" class="required">
                <a-month-picker style="width:100%;" :placeholder="$t('news.dealForm.signDatePlaceholder')"
                                v-decorator="decorators.signTime" :disabled="disabled"></a-month-picker>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('lease.modal.successBy')">
                <pt-select :placeholder="$t('lease.modal.selectTip')" show-search v-decorator="decorators.agent"
                           :disabled="disabled" :showArrow="!disabled">
                  <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">{{ c.companySortNameCn }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.dealForm.remarksLabel')">
                <pt-input :class="!disabled ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}"
                          v-decorator="decorators.remark"
                          :placeholder="$t('lease.modal.remarksTip')" :disabled="disabled">
                </pt-input>
                <!--  <a-textarea :disabled="disabled"
                    :rows="3"
                    :placeholder="$t('lease.modal.remarksTip')"
                    v-decorator="decorators.remarks"
                  />-->
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
    <pt-modal :title="customerModalTitle" :visible="customerModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot="content">
        <add-customer v-model="customerModalTitle" ref="customerModel" @saveSuccess="saveSuccess"></add-customer>
      </div>
    </pt-modal>
    <pt-modal :title="$t('mansion.addMansion.addTitle')" :visible="addMansionVisible"
              @ok="addMansion" @cancel="cancelAddMansion" :width="800"
    >
      <div slot="content">
        <quickly-add-mansion ref="addMansionRef" @saveSuccess="saveMansionSuccess"></quickly-add-mansion>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import unitApi from '@/api/manager/unit'
import customerApi from '@/api/mine/customer'
import mansionApi from '@/api/database/mansion'
import mansionFloorApi from '@/api/database/mansionFloor'
import leaseApi from '@/api/database/lease'
import colleagueApi from '@/api/database/colleague'
import AddCustomer from '../../../database/customer/module/addCustomer'
import QuicklyAddMansion from '../../../database/mansionData/quicklyAddMansion'
import moment from "moment";

export default {
  name: 'newsLeaseForm',
  components: {
    QuicklyAddMansion,
    AddCustomer,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
		city:{
			type:String,
			default:''
		},
    transfer: {
      type: Boolean,
      default: false,
    },
    fromNewsDO: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },isNewsAmendment: {
      type: Boolean,
      default: false
    },
    mansionList: {
      type: Array,
      default: []
    },
    newsDO: {
      type: Object,
      default: null
    },
    customerVO: {},
    unitVO: {},
    companyShow: {
      type: Boolean,
      default: true
    },
    leaseId: {
      type: String,
      default: undefined
    },
    dealId: {
      type: String,
      default: null
    },
    defaultAreaUnit: {
      type: String,
      default: null,
    },
    defaultRentUnit: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
			nowCity:'',
      currLeaseId: null,
      currMansionId: null,
      oldBuildingAdd: false, //标识从原大厦选项点击新增大厦
      unitAllData: [],
      currAgentName: null,
      currCustomerName: null,
      currMansionName: null,
      defaultCustomerId: undefined,
      leaseInfoDOS: this.newsDO ? JSON.parse(JSON.stringify(this.newsDO.leaseLeaseInfoTypeVOS)) : [],
      dealTypeList: [
        {key: '新设立', active: false},
        {key: '搬迁', active: false},
        {key: '续租', active: false},
        {key: '租约重构', active: false},
        {key: '扩租', active: false},
        {key: '购买', active: false},
      ],
      addMansionVisible: false,
      customerModalVisible: false,
      customerModalTitle: '',
      dateRange: null,
      leaseInfoVO: {},
      leaseLeaseInfoDetailsVOList: [],
      mansionOptions: [],
      oldMansionOptions: [],
      colleagueList: [],
      competitors: [],
      floorOptions: [],
      leaseForm: this.$form.createForm(this, {}),
      customerList: [],
      decorators: {
        dateRange: [
          'dateRange', {rules: [{required: true, message: this.$t('news.dealForm.leasePeriodPlaceholder')}]}
        ],
        customerId: [
          'customerId', {rules: [{required: true, message: this.$t('lease.modal.companyTip')}]}
        ],
        mansion: [
          'mansion', {rules: [{required: true, message: this.$t('lease.modal.buildingTip')}]}
        ],
        newMansionId: [
          'newMansionId', {rules: [{required: true, message: this.$t('lease.modal.buildingTip')}]}
        ],
        oldMansionId: [
          'oldMansionId', {}
        ],
        mansionName: [
          'mansionName', {}
        ],
        floorId: [
          'floorId', {}
        ],
        unitCode: [
          'unitCode', {}
        ],
        leaseArea: [
          'leaseArea', {}
        ],
        areaSizeUnit: [
          'areaSizeUnit', {}
        ],
        rent: [
          'rent', {rules: [{required: true, message: this.$t('news.dealForm.rentPlaceholder')}]}
        ],
        rentUnit: [
          'rentUnit', {}
        ],
        startTime: [
          'startTime', {}
        ],
        endTime: [
          'endTime', {}
        ],
        propertyType: [
          'propertyType', {}
        ],
        remarks: ['remarks', {rules: [{max: 1024, message: this.$t('news.contentMaxLenTip')}]}],
        remark: ['remark', {rules: [{max: 1024, message: this.$t('news.contentMaxLenTip')}]}],
        dueDatePrice: [
          'dueDatePrice', {rules: [{max: 100, message: this.$t('news.increasingLenTip')}]}
        ],
        rentFreePeriod: [
          'rentFreePeriod', {rules: []}
        ],

        purchaseType: [
          'purchaseType', {rules: [{required: true, message: '请选择购买方式'}]}
        ],
        area: [
          'area', {rules: [{required: true, message: '请输入估计成交面积'}]}
        ],
        comment: [
          'comment'
        ],
        storeyIds: [
          'storeyIds'
        ],
        unitPrice: [
          'unitPrice'
        ],
        price: [
          'price', {rules: [{required: true, message: '请输入估计成交价格'}]}
        ],
        useType: [
          'useType', {rules: [{required: true, message: '请选择用途'}]}
        ],
        payType: [
          'payType', {rules: [{required: true, message: '请选择付款方式'}]}
        ],


        inTime: ['inTime', {}],
        signTime: ['signTime', {rules: [{required: true, message: this.$t('news.dealForm.signDatePlaceholder')}]}],
        agent: ['agent', {}],
        competeAgent: ['competeAgent', {rules: [{max: 256, message: this.$t('news.contentLenTip')}]}],
        dueTime: ['dueTime', {initialValue: undefined}],

      },
      paySaveVO: {
        area: 0,
        price: 0,
      },
      showFloor:[]
    }
  },
  mounted() {
    this.initDealTypes();
    this.initAllUnit();
    if (this.isOldData) {
      this.initCompetitors()
    } else {
      this.addFloor()
      this.init();
    }
		if(this.newsDO){
			this.nowCity = this.newsDO.city;
		}else{
			this.nowCity = this.city;
		}
  },
  computed: {
    isOldData() {
      if (this.newsDO) {
        return this.$moment(this.newsDO.createTime).isBefore(this.$moment('2020-03-22'))
      } else {
        return false
      }
    }
  },
  methods: {
    floorNumChanges(values){
      if(values && values.length > 0){
        console.log(values)
        this.showFloor = [];
        values.forEach((data,index)=>{
          if(index > 2){
            let item = this.floorOptions.find(o=>o.id == data);
            this.showFloor.push(item.floorNum);
          }
        })
      }
    },
    priceChange(value) {
      console.log(value)
      this.paySaveVO.price = value;
      this.setUnitPrice();
    },
    areaChange(value) {
      console.log(value)
      this.paySaveVO.area = value;
      this.setUnitPrice();
    },
    setUnitPrice() {
      console.log(this.paySaveVO.price,this.paySaveVO.area,this.city)
      if (this.paySaveVO.price && this.paySaveVO.area) {
        console.log(this.paySaveVO.price,this.paySaveVO.area)
	      if(this.city.toUpperCase() == 'HK'){
		      this.leaseForm.setFieldsValue({unitPrice: this.paySaveVO.price * 1000000 / this.paySaveVO.area .toFixed(2)})
	      }else{
		      this.leaseForm.setFieldsValue({unitPrice: this.paySaveVO.price / this.paySaveVO.area .toFixed(2)})
	      }

      }
    },
    initAllUnit() {
      unitApi.selectAll().then(res => {
        if (res.code == 1) {
          this.unitAllData = res.data ? res.data : []
        }
      })
    },
    monthChange(data) {
      console.log("change========")
      this.dateRange = data;
    },
    oldBuildingChange(value) {
      let name = this.oldMansionOptions.find(e => {
        return e.id == value
      }).name
      this.leaseForm.setFieldsValue({
        mansionName: name
      })
    },
    initDealTypes() {
      let newsDO = this.newsDO
      if (newsDO && newsDO.dealType) {
        this.dealTypeList.forEach(e => {
          if (newsDO.dealType == e.key || newsDO.dealType.split(',').indexOf(e.key + '') >= 0) {
            e.active = true
          } else {
            e.active = false
          }
        })
      }
    },
    submit() {
      let newLeaseInfoVO = this.extractLeaseInfoVO();
      if (newLeaseInfoVO) {
        if (this.newsDO && this.leaseInfoVO) { //编辑时租约可能有附件的情况，取原附件信息
          newLeaseInfoVO.leaseAttachmentDOS = this.leaseInfoVO.leaseAttachmentDOS;
        } else {
          newLeaseInfoVO.leaseAttachmentDOS = [];
        }
        let leaseInfoTypeVO = {newLease: true, leaseLeaseInfoVO: newLeaseInfoVO}

        // let newsVO = this.dealForm.getFieldsValue()
        let dealTypeList = this.dealTypeList.filter(e => {
          return e.active
        });
        if (dealTypeList.length == 0) {
          this.$message.warning("请选择交易类型!")
          return false;
        }
        let newsVO = {};
        let dealType = dealTypeList.map(b => {
          return b.key
        }).join(',')
        if (dealType == '购买') {
          console.log("合并前数据", newLeaseInfoVO)
          newsVO = JSON.parse(JSON.stringify(newLeaseInfoVO));
          console.log("合并后数据", newsVO)
        }
        newsVO.dealType = dealType;
        newsVO.leaseLeaseInfoTypeVOS = [];
        newsVO.leaseLeaseInfoTypeVOS.push(leaseInfoTypeVO)

        //处理动态展示文本
        this.mansionOptions.forEach(e => {
          if (e.id == newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.mansion) {
            this.currMansionName = e.name;
          }
        });
        this.customerList.forEach(e => {
          if (e.id == newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.customerId) {
            this.currCustomerName = e.companySortNameCn;
          }
        })
        if (newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.agent) {
          this.competitors.forEach(e => {
            if (e.id == newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.agent) {
              this.currAgentName = e.companySortNameCn;
            }
          })
        }
        if (this.fromNewsDO) {
          newsVO.city = this.fromNewsDO.city;
        }
        newsVO.oldMansionId = newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.oldMansionId
        newsVO.mansion = newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.mansionName
        console.log("获取数据", newsVO)
        delete newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.mansionId
        delete newsVO.leaseLeaseInfoTypeVOS[0].leaseLeaseInfoVO.mansionName
        return newsVO
      } else {
        return false;
      }
    },
    filterUnit(unitId) {
      let curUnit = this.unitAllData.find(data => {
        return data.id == unitId
      })
      if (curUnit) {
        return curUnit.shortName;
      } else {
        return '';
      }
    },
    switchDealType(item) {
      if (item == 5) {
        this.dealTypeList.forEach(data => {
          data.active = false;
        })
        this.dealTypeList[item].active = !this.dealTypeList[item].active;
      } else {
        this.dealTypeList[item].active = !this.dealTypeList[item].active;
        this.dealTypeList[5].active = false;
      }

    },
    addMansion() {
      this.$refs.addMansionRef.submit();
    },
    cancelAddMansion() {
      this.addMansionVisible = false;
    },
    saveMansionSuccess(mansionId, mansionName) {
      let newMansionObj = {
        id: mansionId,
        name: mansionName
      }
      if (this.oldBuildingAdd) {
        this.oldMansionOptions = [];
        this.oldMansionOptions.push(newMansionObj);
        this.leaseForm.setFieldsValue({
          oldMansionId: mansionId
        });
      } else {
        this.mansionOptions = [];
        this.mansionOptions.push(newMansionObj);
        this.leaseForm.setFieldsValue({
          mansion: mansionId,
          newMansionId: mansionId,
        });
        this.clearFloorList();
        this.initMansionFloorOptions(mansionId);
      }
      this.addMansionVisible = false;
    },
    openAddMansionModal(type) {
      if (type == 'old') {
        this.oldBuildingAdd = true;
      } else {
        this.oldBuildingAdd = false;
      }
      this.addMansionVisible = true;
    },
    addFloor() {
      let areaSizeUnit = this.leaseLeaseInfoDetailsVOList.length > 0 ? this.leaseLeaseInfoDetailsVOList[0].areaSizeUnit : this.defaultAreaUnit;
      this.leaseLeaseInfoDetailsVOList.push({areaSizeUnit: areaSizeUnit});
      let keys = this.leaseForm.getFieldValue('leaseLeaseInfoDetailsVOList') ? this.leaseForm.getFieldValue('leaseLeaseInfoDetailsVOList') : [];
      keys.push({
        areaSizeUnit: areaSizeUnit,
        mansionId: this.currMansionId,
        leaseId: this.currLeaseId,
        floorId: undefined,
        unitCodes: undefined,
        areaSize: undefined,
      });
      this.$nextTick(() => {
        this.leaseForm.setFieldsValue({
          leaseLeaseInfoDetailsVOList: keys
        })
      })
    },
    cancelAddCustomer() {
      this.customerModalVisible = false;
    },
    customerIdChange(value) {
      this.defaultCustomerId = value;
    },
    extractLeaseInfoVO() {
      let leaseLeaseInfoVO = null;
      let curAreaSizeUnit = this.defaultAreaUnit;
      try{
        this.leaseForm.validateFields((err, values) => {
          console.log("获取数据", values)
          if (!err) {
            leaseLeaseInfoVO = this.leaseForm.getFieldsValue()
            console.log("获取数据", leaseLeaseInfoVO)
            leaseLeaseInfoVO.mansion = values.mansion;
            leaseLeaseInfoVO.oldMansionId = values.oldMansionId;
            if (leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.length > 1) { //处理无效楼层数据
              leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList = leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.filter((e, index) => {
                return e.floorId != null || e.areaSize != null || e.unitCodes != null || index == 0
              })
            }
            leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.forEach((item, index) => {
              item.areaSizeUnit = curAreaSizeUnit;
            })
            leaseLeaseInfoVO.colleagueDOS = this.colleagueList.map(e => {
              return {id: e}
            })
          } else {
            console.log(err)
            console.log(values)
            console.log('交易记录表单校验不通过');
          }
        })
      }catch (e){
        console.log(e)
      }
      if (this.dateRange != null && this.dateRange.length > 0) {
        leaseLeaseInfoVO.startTime = this.dateRange[0].format('YYYY-MM-01')
        leaseLeaseInfoVO.endTime = this.dateRange[1].format('YYYY-MM-01')
      }
      console.log("获取数据", leaseLeaseInfoVO)
      return leaseLeaseInfoVO
    },
    deleteFloorRow(index) {
      let keys = this.leaseForm.getFieldValue('leaseLeaseInfoDetailsVOList');
      this.leaseForm.setFieldsValue({
        leaseLeaseInfoDetailsVOList: keys.filter((item, i) => index !== i),
      })
      this.leaseLeaseInfoDetailsVOList.splice(index, 1);
    },
    handleSearch(customerName) {
      setTimeout(() => {
        customerApi.queryByName({name: customerName}).then(res => {
          this.customerList = res.data
        })
      }, 300);
    },
    init() {
      if (this.newsDO && this.newsDO.informationType == '交易记录' && this.newsDO.dealType != '购买') {
        let curData = JSON.parse(JSON.stringify(this.newsDO.leaseLeaseInfoTypeVOS));
        let arr = [];
        if (curData) {
          arr = this.leaseInfoDOS.filter(e => {
            return e.newLease == true
          }).map(f => {
            return f.leaseLeaseInfoVO
          })
          this.leaseInfoVO = arr[0];
          this.currMansionId = this.leaseInfoVO.mansion;
          this.currLeaseId = this.leaseInfoVO.id;
        } else {
          this.leaseInfoVO = null;
        }
        // this.leaseInfoVO = this.defaultLeaseInfoVO
        this.leaseLeaseInfoDetailsVOList = this.leaseInfoVO.leaseLeaseInfoDetailsVOList
        Promise.all(
          [
            this.initMansionOptionsWithMansionid(this.leaseInfoVO.mansion, 1),
            this.initMansionOptionsWithMansionid(this.newsDO.oldMansionId, 2),
            this.initMansionFloorOptions(this.leaseInfoVO.mansion),
            this.initCustomerOptions(this.leaseInfoVO.customerId)
          ]
        ).then(() => {
          if (this.leaseInfoVO.startTime != '~' && this.leaseInfoVO.startTime) {
            this.leaseInfoVO.dateRange = [this.$moment(this.leaseInfoVO.startTime), this.$moment(this.leaseInfoVO.endTime)];
            this.dateRange = [this.$moment(this.leaseInfoVO.startTime), this.$moment(this.leaseInfoVO.endTime)]
          }

          if (this.leaseInfoVO.inTime != '~' && this.leaseInfoVO.inTime) {
            this.leaseInfoVO.inTime = this.$moment(this.leaseInfoVO.inTime)
          } else {
            this.leaseInfoVO.inTime = undefined;
          }
          if (this.leaseInfoVO.signTime != '~' && this.leaseInfoVO.signTime) {
            this.leaseInfoVO.signTime = this.$moment(this.leaseInfoVO.signTime)
          } else {
            this.leaseInfoVO.signTime = undefined;
          }
          this.colleagueList = this.leaseInfoVO.colleagueDOS != null ? this.leaseInfoVO.colleagueDOS.map(e => {
            return e.id
          }) : []
          this.leaseInfoVO.agent = this.leaseInfoVO.agent == '0' ? undefined : this.leaseInfoVO.agent;
          this.leaseInfoVO.mansionName = this.newsDO.mansionName
          if (this.disabled) {
            this.leaseInfoVO.oldMansionId = this.newsDO.oldMansionId !== '0' ? this.newsDO.oldMansionId : "~"
            if (this.leaseInfoVO.dueTime == 0) {
              this.leaseInfoVO.dueTime = '~'
            }
            if (!this.leaseInfoVO.agent) {
              this.leaseInfoVO.agent = '~'
            }
            if (this.leaseInfoVO.leaseLeaseInfoDetailsVOList && this.leaseInfoVO.leaseLeaseInfoDetailsVOList.length > 0) {
              this.leaseInfoVO.leaseLeaseInfoDetailsVOList.forEach(e => {
                if (e.floorId == 0) {
                  e.floorId = '~'
                }
              })
            }
          } else {
            this.leaseInfoVO.oldMansionId = this.newsDO.oldMansionId !== '0' ? this.newsDO.oldMansionId : undefined;
            if (this.leaseInfoVO.dueTime == 0) {
              this.leaseInfoVO.dueTime = undefined
            }
            if (this.leaseInfoVO.leaseLeaseInfoDetailsVOList && this.leaseInfoVO.leaseLeaseInfoDetailsVOList.length > 0) {
              this.leaseInfoVO.leaseLeaseInfoDetailsVOList.forEach(e => {
                if (e.floorId == 0) {
                  e.floorId = undefined
                }
                if (e.areaSize == '~') {
                  e.areaSize = undefined
                }
                if (e.unitCodes == '~') {
                  e.unitCodes = undefined
                }
              })
            }
            this.leaseInfoVO.dueDatePrice == '~' && (this.leaseInfoVO.dueDatePrice = undefined)
          }

          this.leaseForm.setFieldsValue(this.leaseInfoVO)
        })
      }  else if(this.newsDO && this.newsDO.dealType == '购买'){
        console.log("购买回显处理",this.newsDO)
        Promise.all(
          [
            this.initMansionOptionsWithMansionid(this.newsDO.newMansionId, 1),
            this.initMansionFloorOptions(this.newsDO.newMansionId),
            this.initCustomerOptions(this.newsDO.customerId)
          ]
        ).then(() => {
          this.dateRange = [this.$moment(), this.$moment()]
          this.newsDO.signTime = moment(this.newsDO.signTime);
          this.newsDO.agent = this.newsDO.agent == 0 ?undefined:this.newsDO.agent;
          this.newsDO.comment = this.newsDO.comment == "~" ?undefined:this.newsDO.comment;
          this.newsDO.dateRange = [this.$moment(), this.$moment()];
          this.paySaveVO.area = parseFloat(this.newsDO.area.replaceAll(",",""));
          this.paySaveVO.price = parseFloat( this.newsDO.price.replaceAll(",",""));
          this.floorNumChanges(this.newsDO.storeyIds);
          this.leaseForm.setFieldsValue(this.newsDO)
        })
      } else {
        if (this.defaultCustomerId) {
          this.initCustomerOptions(this.defaultCustomerId)
        }
        console.log("市场动态信息", this.fromNewsDO);
        // this.leaseForm.setFieldsValue({rentUnit:this.defaultRentUnit,customerId:this.defaultCustomerId})
        // this.leaseLeaseInfoDetailsVOList[0]["areaSizeUnit"] = this.defaultAreaUnit
        this.$nextTick(() => {
          /**
           * 业主动态/租户动态 转交易记录
           */
          if (this.transfer && (this.fromNewsDO.informationType == '租户动态' || this.fromNewsDO.informationType == '业主动态')) {
            if (this.fromNewsDO.informationType == '租户动态') {
              Promise.all([
                this.initCustomerOptions(this.fromNewsDO.customerId)
              ]).then(() => {
                this.leaseForm.setFieldsValue({
                  customerId: this.fromNewsDO.customerId,
                  leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList,
                  rentUnit: this.defaultRentUnit,
                  remarks: this.fromNewsDO.content
                })
              })
            } else {
              Promise.all(
                [
                  this.initMansionOptionsWithMansionid(this.fromNewsDO.ownerProjectId, 1),
                  this.initMansionFloorOptions(this.fromNewsDO.ownerProjectId),
                ]).then(() => {
                this.leaseForm.setFieldsValue({
                  mansion: this.fromNewsDO.ownerProjectId,
                  leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList,
                  rentUnit: this.defaultRentUnit,
                  remarks: this.fromNewsDO.content
                })
              })
            }
          } else {
            this.leaseForm.setFieldsValue({
              customerId: this.defaultCustomerId,
              leaseLeaseInfoDetailsVOList: this.leaseLeaseInfoDetailsVOList,
              rentUnit: this.defaultRentUnit,
            })
          }
        })
      }
      this.initCompetitors()
    },
    initCompetitors() {
      colleagueApi.selectAll().then(res => {
        if (res.code == 1) {
          this.competitors = res.data.records
        }
      })
    },
    initCustomerOptions(id) {
      let p = new Promise((resolve, reject) => {
        customerApi.selectOne(id).then(res => {
          if (res.code == 1) {
            this.customerList = [res.data]
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
    initLeaseInfoVO() {
      let p = new Promise((resolve, reject) => {
        leaseApi.selectOne(this.leaseId).then(res => {
          if (res.code == 1) {
            let temp = JSON.stringify(res.data)
            this.leaseInfoVO = JSON.parse(temp.replace(/\"~\"/g, null))
            let index = 0
            this.leaseLeaseInfoDetailsVOList = this.leaseInfoVO.leaseLeaseInfoDetailsVOList
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
    initMansionOptionsWithMansionid(id, list) {
      if (id !== '0') {
        let p = new Promise((resolve, reject) => {
          mansionApi.selectOne(id, 2).then(res => {
            if (res.code == 1) {
              if (list == 1) {
                this.mansionOptions = [res.data];
              } else {
                this.oldMansionOptions = [res.data];
              }
              resolve()
            } else {
              reject()
            }
          })
        })
        return p
      }
    },
    initNewMansionOptions(value) {
      this.initMansionOptions(value, 1)
    },
    initOldMansionOptions(value) {
      this.initMansionOptions(value, 2)
    },
    initMansionOptions(value, list) {
      if (value == null || value == '' || value == '0' || value == '~') {
        return
      }
      mansionApi.listAll({queryText: value}).then(res => {
        if (res.code == 1) {
          if (list == 1) {
            this.mansionOptions = res.data
          } else {
            this.oldMansionOptions = res.data
          }
        }
      })
    },
    mansionIdChange(mansionId) {
      if(this.newsDO && this.newsDO.id){
        this.$message.warning("请注意修改大厦，楼层、单元、面积会清空。")
      }
      this.currMansionId = mansionId;
      this.clearFloorList();
      this.initMansionFloorOptions(mansionId);
    },
    initMansionFloorOptions(mansionId) {
      if (mansionId) {
        mansionFloorApi.listByMansionId(mansionId).then(res => {
          if (res.code == 1) {
            this.floorOptions = res.data;
          }
        })
      }
    },
    clearFloorList() {
      this.leaseLeaseInfoDetailsVOList = null;
      this.leaseForm.setFieldsValue({
        leaseLeaseInfoDetailsVOList: null,
      })
      this.$nextTick(() => {
        this.leaseLeaseInfoDetailsVOList = [{}];
        this.leaseForm.setFieldsValue({
          leaseLeaseInfoDetailsVOList: [{}],
        })
      })
    },
    openAddCustomerModal() {
      this.customerModalVisible = true;
    },
    saveCustomer() {
      this.$refs.customerModel.submit();
    },
    saveSuccess(id, name, customer) {
      this.customerList = [];
      let customerDO = {
        id: id,
        companyName: name,
        companySortNameCn: customer.companySortNameCn
      }
      this.customerList.push(customerDO);
      this.leaseForm.setFieldsValue({
        customerId: id
      })
      this.customerModalVisible = false;
    },
  }
}
</script>

<style scoped lang="less">
.statusRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: rgba(248, 249, 251, 0.62);;
  padding: 40px 20px 20px 20px;

  .statusSelected {
    min-width: 80px;
    transition: background-color .15s ease-in-out;
    background: #FABE00;
    border-radius: 4px;
    /*width: 90px;*/
    padding: 0 12px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #333333;
    cursor: pointer;
    margin-right: 28px;
  }

  .statusDefault {
    min-width: 80px;
    transition: background-color .15s ease-in-out;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    border-radius: 4px;
    padding: 0 12px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #333333;
    cursor: pointer;
    margin-right: 28px;
  }
}

.addBottomBtn {
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;

  .addIcon {
    color: #ffffff;
    font-size: 12px;
  }

  .addBtnText {
    font-size: 12px;
    color: #ffffff;
    margin-left: 4px;
  }
}

#addLease {
  .disabledClass {
    border: 1px solid #d9d9d9 !important;
  }

  .greyDiv {
    padding: 20px;
    background: rgba(248, 249, 251, 0.62);
    border-radius: 0 0 4px 4px;
  }

  .deleteBtn {
    margin-top: 10px;
    margin-right: 8px;
    cursor: pointer;

    .delIcon {
      font-size: 18px;
    }
  }

  .fileRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px 0;

    .fileRowLeft {
      display: flex;
      flex-direction: row;
      align-items: center;

      .circle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #FABE00;
      }

      .fileTitle {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
      }

      .fileTip {
        font-size: 12px;
        color: #999999;
        margin-top: 4px;
        margin-left: 4px;
      }
    }
  }

  .ant-form-item {
    padding: 0 10px;
  }

  .lease_floor {
    padding: 10px 0;
    position: relative;
    background: #F4F5F8;
    border-radius: 0 0 4px 4px;
  }
}

.addCustomerBtn {
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;

  .addIcon {
    color: #ffffff;
    font-size: 12px;
  }
}

.ant-select-disabled {
  color: rgba(0, 0, 0, 0.65);
}

.ant-input-number-disabled {
  color: rgba(0, 0, 0, 0.65) !important;
}

/deep/ .ant-input-disabled {
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .invisible-item {
  display: none;
}

/deep/ .maximum-length {
  width: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="less">
.ant-select-dropdown-content {
  /deep/ .invisible-item {
    display: initial !important;
  }
}
</style>